import React from "react";

/**
 * TopicPlanNote — what the plan says about one topic of a class formed from a
 * module-wise syllabus: which part of a long topic this class covers, and
 * whether it was carried over from an earlier class. Nothing for a day's topic.
 *
 * Props: topic ({ part, parts, carriedFrom })
 */
const TopicPlanNote = ({ topic }) => {
  const notes = [];
  if (topic?.parts > 1) notes.push(`part ${topic.part} of ${topic.parts}`);
  if (topic?.carriedFrom != null) notes.push(`carried from class ${topic.carriedFrom}`);
  if (!notes.length) return null;
  return <span className="tw-ms-1.5 tw-text-xs tw-font-normal tw-text-content-muted">· {notes.join(" · ")}</span>;
};

export default TopicPlanNote;
